import React from "react";
import styled from "styled-components";

export const DetailPanelItem = styled.p`
    font-size: 0.8rem;
    strong {
        display: block;
    }
`;
